import CustomButton from "../CustomButton/CustomButton";
import { useGoogleLogin } from '@react-oauth/google';

function GoogleLogin(props) {
  const loginGoogleWrapper = useGoogleLogin({
    flow: 'implicit',
    onSuccess: tokenResponse => props.onSuccess(tokenResponse),
    onError: err => props.onFailure(err),
  });


  return (
    <div>
      <CustomButton
        onClick={() => loginGoogleWrapper()}
        round
        color="primaryDark"
        // style={getButtonStyle()}
        text={props.text}
      />
    </div>
  );
}

export default GoogleLogin;